"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantLastDate = void 0;
const dayjs = require("dayjs");
const getOrderLineStardEndDate_1 = require("./getOrderLineStardEndDate");
const getVariantLastDate = (variant) => {
    if (!variant || !variant.order_lines || variant.order_lines.length === 0) {
        return dayjs().format("YYYY-MM-DD");
    }
    const dates = [];
    variant.order_lines.forEach((line) => {
        const orderLineDate = (0, getOrderLineStardEndDate_1.getOrderLineStartEndDate)(line);
        if (!orderLineDate)
            return;
        dates.push(dayjs(orderLineDate.end, "DD-MM-YYYY"));
    });
    if (dates.length === 0) {
        return dayjs().format("YYYY-MM-DD");
    }
    const lastDate = dates.reduce((a, b) => (a.isAfter(b) ? a : b));
    return lastDate.add(1, "days").format("YYYY-MM-DD");
};
exports.getVariantLastDate = getVariantLastDate;
